import { render } from "./Search.vue?vue&type=template&id=f641dff0&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=f641dff0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f641dff0"]])

export default __exports__